import React, { useContext, useEffect, useMemo, useState } from "react";
import TgridFlexPostsList from "./TgridFlexPosts/TgridFlexPostsList";
import TgridEditorForm from "./TgridEditorForm/TgridEditorForm";
import { AuthContext } from "../../../context/App-Context";
import axios from "axios";
import OcancerzWorldStartingConsole from "../../../OcancerzHeaven/OcancerzWorldConsole/OcancerzWorldStartingConsole";

const TempleGridFlexDashboard = () => {
  const auth = useContext(AuthContext);
  const [editingPost, setEditingPost] = useState(null);
  const [posts, setPosts] = useState([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState("June 2026");

  useEffect(() => {
    const fetchData = async () => {
      // console.log("starting");
      try {
        //setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/getusertemplegridposts/${auth.loginVar}`
        ); // Example API endpoint
        // console.log(response.data.data[0]);
        // console.log(response.data.data[0].username);
        setPosts(response.data.data.functionGo);
        //console.log(response.data.data);
        //console.log(data.functionGo);
      } catch (err) {
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
    //console.log(auth.loginVar);
  }, [auth.loginVar]);
  const dateOptions = useMemo(() => {
    if (posts) {
      const validMonthYears = posts
        .map((post) => {
          if (!post?.postDate || typeof post.postDate !== "string") return null;

          const datePart = post.postDate.split(",")[0].trim(); // "3/28/2026"
          const dateObj = new Date(datePart);

          if (isNaN(dateObj.getTime())) return null;

          return dateObj.toLocaleString("default", {
            month: "long",
            year: "numeric",
          });
        })
        .filter(Boolean);

      const uniqueSorted = [...new Set(validMonthYears)].sort(
        (a, b) => new Date(b) - new Date(a)
      );

      return uniqueSorted.length > 0 ? uniqueSorted : ["Starting..."];
    }
  }, [posts]);

  const filteredPosts = useMemo(() => {
    if (!posts || !posts.length) return [];

    return posts.filter((post) => {
      if (!post?.postDate || typeof post.postDate !== "string") {
        return false; // ← Strictly exclude posts with no date
      }

      const datePart = post.postDate.split(",")[0].trim();
      const dateObj = new Date(datePart);

      if (isNaN(dateObj.getTime())) return false;

      const postMonthYear = dateObj.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });

      return postMonthYear === selectedMonthYear;
    });
  }, [posts, selectedMonthYear]);

  useEffect(() => {
    if (dateOptions) {
      if (dateOptions.length > 0 && dateOptions[0] !== selectedMonthYear) {
        setSelectedMonthYear(dateOptions[0]);
      }
    }
  }, [dateOptions]);

  return (
    <div className="templegrid">
      <div className="templegrid-courtyard-setting"></div>
      <main className="templegrid-main">
        {/* Post creation input */}

        <TgridEditorForm
          bubblesForm
          editingPost={editingPost}
          setEditingPost={setEditingPost}
        />

        {/* <div>{!editingPost && <div>no posts yet</div>}</div> */}

        {/* Feed – current/recent posts */}
        {posts && (
          <TgridFlexPostsList
            onEditPost={setEditingPost}
            postFunction={posts}
          />
        )}
        {/* <div>{!filteredPosts && <div>no posts yet</div>}</div> */}
      </main>

      {/* Right sidebar – fixed/sticky */}
      {/* <aside className="templegrid-sidebar">
        
        <div className="sidebar-section dates">
          <h3>Dates</h3>
          <ul>
            {posts &&
              dateOptions.map((monthYear) => (
                <li
                  key={monthYear}
                  className={selectedMonthYear === monthYear ? "active" : ""}
                  onClick={() => setSelectedMonthYear(monthYear)}
                  style={{ cursor: "pointer" }}
                >
                  {monthYear}
                </li>
              ))}
            
          </ul>
        </div>

       
        <div className="sidebar-section gather">
          <h3>Ocancerz</h3>
          <h3>bubbles</h3>
          <div className="gather-item">human</div>
          <div className="gather-item">home</div>
          <div className="gather-item">geo</div>
         
          <button className="btn-add">+ New Collection</button>
        </div>
      </aside> */}
      <OcancerzWorldStartingConsole />
    </div>
  );
};

export default TempleGridFlexDashboard;
